var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white p-2"},[_c('div',[_vm._v("Cuộc gọi thoại")]),_c('div',[_vm._v(_vm._s(_vm.responseTime(_vm.duration))+" giây")])])
}
var staticRenderFns = []

export { render, staticRenderFns }